/*
 * @Author: ymk
 * @Date: 2020-07-23 10:17:36
 * @LastEditors: ymk
 * @LastEditTime: 2020-07-28 19:11:14
 * @FilePath: \car-demo\src\plugin.js
 */

import Vue from 'vue'
import {
	Row,
	Col,
	Swiper,
	Dialog,
	Picker,
	DatePicker,
	Noticebar,
	Cell,
	Popup,
	scroller,
	textinput,
	searchbar,
	LuckDraw,
	Avatar,
	Button,
	Stepper,
	Toast,
	infiniteloading,
	Icon,
	checkbox,
	radio,
	Badge,
	TextInput,
	textbox,
	Uploader,
	Address,
	CountDown,
} from '@nutui/nutui'

import VueMeta from 'vue-meta'
import { vueBaberrage } from 'vue-baberrage'
// import Danmu from '@/components/Danmu'
import List from '@/components/List'
import Tab from '@/components/Tab'

Row.install(Vue)
Col.install(Vue)
Swiper.install(Vue)
Dialog.install(Vue)
Picker.install(Vue)
DatePicker.install(Vue)
Noticebar.install(Vue)
Cell.install(Vue)
Popup.install(Vue)
scroller.install(Vue)
textinput.install(Vue)
searchbar.install(Vue)
LuckDraw.install(Vue)
Avatar.install(Vue)
Button.install(Vue)
Stepper.install(Vue)
Toast.install(Vue)
infiniteloading.install(Vue)
Icon.install(Vue)
checkbox.install(Vue)
radio.install(Vue)
Badge.install(Vue)
TextInput.install(Vue)
textbox.install(Vue)
Uploader.install(Vue)
CountDown.install(Vue)
Address.install(Vue)

Vue.use(VueMeta, {
	refreshOnceOnNavigation: true,
})
Vue.use(vueBaberrage)

// Vue.use(Danmu)
Vue.component('List', List)
Vue.component('Tab', Tab)
